(function () {
  function normalizeProductTitles() {
    const titles = document.querySelectorAll(".featured-product .product__title")
    titles.forEach(title => {
      if (title.dataset.normalized) return
      title.textContent = title.textContent.toLowerCase()
      title.dataset.normalized = "true"
    })
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", normalizeProductTitles)
  } else {
    normalizeProductTitles()
  }
})();
